import { formatCurrency } from '@fourthwall/utils/dist/currency'

export const convertNumberToPrice = (
  value: number,
  currency = 'USD',
): { value: string; currency: string } => ({
  value: formatCurrency(value),
  currency,
})
